// extracted by mini-css-extract-plugin
module.exports = {"conclusion":"Conclusion_conclusion__N_zqz","conclusion__container":"Conclusion_conclusion__container__fE7qR","conclusion__line":"Conclusion_conclusion__line__TeUU_"};